import React, { Component } from "react";

import { Query } from "react-apollo";
import gql from "graphql-tag";

import logo from "../../assets/img/porto-seguro.png";
import background from "../../assets/img/background-login.jpg";

class Login extends Component {
  
  render() {
    return (

      <Query
              query={gql`{
                account_auth{
                    login_url
                }
              }
              `}
            >
              {({ loading, error, data }) => {
                if (loading) return <div>Carregando...</div>;
                if (error) return <div>Erro :(</div>;
                  
                return  (
                  
                  <div id="login_page">
                    <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm">
                      <h5 className="my-0 mr-md-auto font-weight-normal"><img src={logo} height="40px" /></h5>
                    </div>
                    <div id="container_login">
                      <img id="container_background" src={background} />
                      <div id="caontainer_content">
                        <div id="box_login" className="cadastro_corretor">
                          <div className="card-deck mb-3 text-center">
                          <form name="Login" method="POST" action="">
                            <input type="HIDDEN" name="SMENC" value="UTF-8" />
                            <input type="HIDDEN" name="SMLOCALE" value="US-EN" />
                            Login:
                            <input type="text" name="USER" size="30" />
                            <br />
                            Senha
                            <input type="password" name="PASSWORD" size="30" />
                            <input type="hidden" name="target" value="https://sso.portoseguro.com.br/siteminderagent/forms/login.fcc" />
                            <input type="hidden" name="smquerydata" value="" />
                            <input type="hidden" name="smauthreason" value="0" />
                            <input type="hidden" name="smagentname" value="xspGLUK6MwWWXj8iNY00MMeYlRHpSL+xbfp+XU6BljOK7/HKtUUkVP1QeXQ0TFYk" />
                            <input type="hidden" name="postpreservationdata" value="" />
                            <input type="submit" value="Login"  />
                          </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  );
              }}
      </Query>

    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx